export default "__VITE_ASSET__ad582bef__"